import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: { breadcrumb: 'Home' },
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "reportedcase" */ '../views/About.vue')
  },
  {
    path: '/watersourcestatus',
    name: 'watersourcestatus',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/WaterSourceStatus.vue')
  },
  {
    path: '/reportedcase',
    name: 'reportedcase',
    component: () => import(/* webpackChunkName: "reportedcase" */ '../views/ReportedCase.vue')
  },
  {
    path: '/feeds',
    name: 'feeds',
    component: () => import('../views/Feeds.vue')
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import(/* webpackChunkName: "reportedcase" */ '../views/Contact.vue')
  },



]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
